import { ProjectTypes } from '@platform/types';
import produce from 'immer';
import { LngLatLike } from 'maplibre-gl';

export const updatePosition = (oldStyleSpec: ProjectTypes.MapSpec, zoom: number, center: LngLatLike) =>
  produce(oldStyleSpec, (draft) => {
    draft.zoom = zoom;
    draft.center = center;
  });

export const removeWorkingLayer = (oldStyleSpec: ProjectTypes.MapSpec, workingLayerId: string) =>
  produce(oldStyleSpec, (draft) => {
    draft.workingLayers = draft.workingLayers.filter((x) => x.id !== workingLayerId);
  });

export const setWorkingLayers = (oldStyleSpec: ProjectTypes.MapSpec, workingLayers: ProjectTypes.AnyWorkingLayer[]) =>
  produce(oldStyleSpec, (draft) => {
    draft.workingLayers = workingLayers;
  });

export const addWorkingLayer = (
  oldStyleSpec: ProjectTypes.MapSpec,
  addedWorkingLayers: ProjectTypes.AnyWorkingLayer[]
) =>
  produce(oldStyleSpec, (draft) => {
    draft.workingLayers.push(...addedWorkingLayers);
  });

export const updateWorkingLayer = (oldStyleSpec: ProjectTypes.MapSpec, workingLayer: ProjectTypes.AnyWorkingLayer) => {
  const workingLayerIndex = oldStyleSpec.workingLayers.findIndex((layer) => layer.id === workingLayer.id);
  return produce(oldStyleSpec, (draft) => {
    draft.workingLayers[workingLayerIndex] = workingLayer;
  });
};

export const changeBaseMap = (oldStyleSpec: ProjectTypes.MapSpec, baseMapId: string) => {
  return produce(oldStyleSpec, (draft) => {
    draft.baseMapId = baseMapId;
  });
};

// export const adjustCutPoints = async (
//   oldStyleSpec: ProjectTypes.MapSpec,
//   newSteps: number[],
//   currentColorPalette: MetadataTypes.ColorPalette
// ) => {
//   const newCutPoints = await figureOutCutPoints(oldStyleSpec.dataLayer.selection, newSteps, currentColorPalette);
//
//   if (!newCutPoints) {
//     console.warn("Can't figure out cut points. Exiting...");
//     return;
//   }
//
//   return produce(oldStyleSpec, (draft) => {
//     draft.dataLayer.rendering = newCutPoints;
//   });
// };
//
// export const addFilterByCriteria = (oldStyleSpec: ProjectTypes.MapSpec, filter: ProjectTypes.WorkingLayerFilterRuleGroupBase) =>
//   produce(oldStyleSpec, (draft) => {
//     draft.workingLayers. = filter;
//   });
